<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :is-form-fetched="isFormFetched"
  >
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';

export default {
  name: 'MasterplanRpSettings',
  components: {
    AdminWrapper,
  },
  data: () => ({
    isFormFetched: false,
    selectedDataSources: [],
  }),
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
  computed: {
    additionalModuleName: get('admin/additionalModules@MASTERPLAN_RP.verbose_name'),
    dataSources: get('layers/metadata'),
    isModuleEnabled: get('admin/settingsValues@masterplan_rp_module_enabled'),
    dataSourcesArray() {
      return this.$_objectToArray(this.dataSources).filter(
        dataSource => dataSource.scope === 'core' && !dataSource.module
      );
    },
    inputs() {
      return [
        {
          name: 'masterplan_rp_datasources',
          translationPath: 'admin.datasourcesTypemasterplan_rp',
          rules: [v => !!v || v == '0' || 'rules.required'],
          dataType: {
            name: 'select',
          },
          multiple: true,
          autoConvertSelect: false,
          align: 'start',
          items: this.dataSourcesArray,
          itemValue: 'name',
          itemText: 'verbose_name',
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'masterplan_rp_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  methods: {
    getDataSources: call('layers/getLayersMetadata'),
    getModulesMapping: call('admin/getModulesMapping'),
    async init() {
      await Promise.all([this.getModulesMapping(), this.getDataSources({ with_attributes_schema: true })]);
      this.isFormFetched = true;
    },
  },
};
</script>
